module.exports = __webpack_public_path__ + "img/carousel-image-2.15ec2c1b.jpg";